import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Header, Text as TextLayout, colors,
} from '@playbookux/playbook-web-core';

const {
  WHITE, GRAY_TEXT, LINK_COLOR, RED,
} = colors;

const OSIconMobile = styled(Icon).attrs(({ variant }) => ({
  name: variant === 'ios' ? 'apple' : 'android',
}))``;
const OSIconDesktop = styled(Icon).attrs(({ platform }) => ({
  name: platform === 'macos' ? 'apple' : 'windows',
}))``;

const TextPrimary = styled(TextLayout)`
  margin-right: 8px;
  align-items: center;
  margin-bottom: 5px;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 680px;
  padding: 25px 15px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background: ${WHITE};
  margin-bottom: 25px;
  align-self: center;
  @media (max-width: 768px) {
    max-width: 95%;
    border-color: #CCC;
  }
`;
const Content = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 25px;
`;

const AmountContainer = styled.div`
  padding: 10px 15px;
`;
const CenterContainer = styled.div`
  flex: 1;
`;

const ResponsiveContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Devices = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;
const DeviceContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const DeviceComputer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const DeviceRow = styled(DeviceContainer)``;
const Device = ({ os, device }) => (
  <DeviceContainer>
    {device === 'computer' && (
      <>
        <DeviceComputer>
          <OSIconDesktop platform="macos" />
          <TextPrimary>Mac Computer</TextPrimary>
        </DeviceComputer>
        <DeviceComputer>
          <OSIconDesktop />
          <TextPrimary>Windows Computer</TextPrimary>
        </DeviceComputer>
      </>
    )}
    {device === 'smartphone' && os.map((each) => (
      <DeviceRow key={each}>
        <OSIconMobile variant={each} />
        <TextPrimary>{each === 'ios' ? 'iPhone' : 'Android Phone'}</TextPrimary>
      </DeviceRow>
    ))}
    {device === 'tablet' && os.map((each) => (
      <DeviceRow key={each}>
        <OSIconMobile variant={each} />
        <TextPrimary>{each === 'ios' ? 'iPad' : 'Android Tablet'}</TextPrimary>
      </DeviceRow>
    ))}
  </DeviceContainer>
);

const Row = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 50px;
`;

const Text = styled(Header)``;

const Amount = styled(Text)``;

const Button = styled(ButtonLayoutComponent)`
  align-self: center;
  margin: 10px 0px !important;
`;

const CloseIcon = styled(Icon).attrs({
  name: 'remove',
})`
  align-self: flex-end;
  margin-bottom: 10px !important;
  cursor: pointer;
`;

export const Image = styled.img`
  height: 15px;
  width: 15px;
  margin-left: 5px;
  margin-right: 3px;
`;

Device.propTypes = {
  os: PropTypes.arrayOf(PropTypes.string).isRequired,
  device: PropTypes.string.isRequired,
};

export const QuestionCounter = styled(TextLayout)`
  text-align: center;
  font-size: 13px;
`;

const Moderated = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;
const ModeratedRaw = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    margin-left: 10px;
  }
`;
Moderated.Title = styled(Text)`
  color: ${GRAY_TEXT} !important;
  margin: 0 0 10px 0 !important;
  text-align: center;
`;
Moderated.Link = styled.span`
  color: ${LINK_COLOR} !important;
  font-weight: bold;
  text-align: center;
  margin: 20px 0px;
  cursor: pointer;
`;
Moderated.Warning = styled.span`
  color: ${RED} !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
`;

Moderated.Text = styled(TextPrimary)`
  text-align: center;
`;

const InfoContainer = styled.div`
  flex: 1;
`;

export {
  Amount,
  Button,
  CenterContainer,
  Container,
  Content,
  CloseIcon,
  Devices,
  Device,
  Text,
  TextPrimary,
  Row,
  OSIconDesktop,
  OSIconMobile,
  AmountContainer,
  ModeratedRaw,
  ResponsiveContainer,
  InfoContainer,
};
